import PropTypes from 'prop-types';
import React, { createContext, useReducer } from 'react';

import { constants } from '@config';

export const ViewportContext = createContext();

export const initialState = {
  zoom: 0.5,
  linkedTextElements: [],
  linkedTextElementChains: [],
  relativePages: {},
  pagePositions: {},
  textBoxPadding: 5,
  textOverflowButtonOffset: 20,
  isDragging: false,
  draggingSlope: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  },
  pagesThumbnail: {}
};
export const Actions = {
  set_pages: 'SET_PAGES',
  set_is_dragging: 'set_is_dragging',
  set_dragging_slope: 'set_dragging_slope',
  zoom_out: 'zoom_out',
  zoom_in: 'zoom_in',
  zoom_fit: 'zoom_fit',
  set_page_thumbnail: 'set_page_thumbnail',
  set_visible_range: 'set_visible_range',
  set_viewport_page_width: 'set_viewport_page_width'
};

const zoomLimits = { upper: 1, lower: 0.2 };

const reducer = (state, action) => {
  switch (action.type) {
    case Actions.set_is_dragging:
      return { ...state, isDragging: action.payload };
    case Actions.set_dragging_slope:
      return { ...state, draggingSlope: action.payload };
    case Actions.set_pages:
      return { ...state, ...action.payload };
    case Actions.zoom_out:
      return { ...state, zoom: Math.max(state.zoom - 0.1, zoomLimits.lower) };
    case Actions.zoom_in:
      return { ...state, zoom: Math.min(state.zoom + 0.1, zoomLimits.upper) };
    case Actions.zoom_fit:
      return { ...state, zoom: 0.5 };
    case Actions.set_page_thumbnail:
      return { ...state, pagesThumbnail: { ...state.pagesThumbnail, [action.payload.id]: action.payload.thumbnail } };
    case Actions.set_visible_range:
      return { ...state, visibleRange: action.payload };
    case Actions.set_viewport_page_width:
      return { ...state, viewportPageWidth: (action.payload * state.zoom) - (constants.text.pagePaddingInPx * 2) };
    default:
      console.error('Unknown action type', action);
      return state;
  }
};

export function ViewportProvider ({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const context = { state, dispatch };

  return (
    <ViewportContext.Provider value={context}>
      {children}
    </ViewportContext.Provider>
  );
}

export function useViewport () {
  const context = React.useContext(ViewportContext);
  return context;
}

ViewportProvider.propTypes = {
  children: PropTypes.node
};
